import { z } from 'zod';

export const AdminPrivateSchema = z.object({
  // Admin Notes & Meta
  adminNotes: z.string().nullable().optional(),
  createdBy: z.string(), // Admin UID
  createdAt: z.any(), // Timestamp
  updatedAt: z.any(),
  updatedBy: z.string(), // Admin UID
  lastLoginAt: z.any().nullable().optional(),
  lastActivityAt: z.any().nullable().optional(),

  // --- FIRMA-AI: SECRETS ---
  whatsappAccessToken: z.string().optional(),
  whatsappPhoneNumberId: z.string().optional(),
  whatsappBusinessAccountId: z.string().optional(),
  webhookVerifyToken: z.string().optional(),

  // --- ACADEMY: SECRETS ---
  academy: z
    .object({
      bunnyLibraryId: z.string().optional(),
      bunnyAccessKey: z.string().optional(),
    })
    .optional(),
});


export type AdminPrivate = z.infer<typeof AdminPrivateSchema>;
